import { Button, DatePicker, Input, Modal, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { CustomDatePicker, CustomInput } from 'components/custom';
import CustomDropdown from 'components/dropdown/custom_select';
import dayjs from 'dayjs';
import useAuth from 'hooks/useAuth';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { absence_type, leave_request_select } from 'utils';
import NESTEDROUTE from 'utils/router';

type LeaveRequestViewProps = {
  cancelledRequest?: (status: string) => void;
  data: any;
};

const LeaveRequestView = ({ cancelledRequest, data }: LeaveRequestViewProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { Text } = Typography;
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = (check: Number) => {
    setOpen(false);
    if (check === 1) {
      cancelledRequest('cancelled');
    } else if (check === 2) {
      cancelledRequest('rejected');
    }
  };
  const showModal1 = () => {
    setOpen1(true);
  };

  const hideModal1 = (check: Number, status: String) => {
    setOpen1(false);
    if (check === 2) {
      navigate(NESTEDROUTE.change_request, {
        state: {
          data: data,
          status: status
        },
      });
    }

  };
  return (
    <div style={{ marginTop: '80px', paddingBottom: '80px' }}>
      {/*PART1 */}
      <div className={'leave_request_form'}>
        <h1 style={{ fontWeight: 700, fontSize: 20, color: '#000000', marginBottom: 32 }}>
          When?
        </h1>
        <div style={{ display: 'flex', gap: '80px', width: '100%' }}>
          <div style={{ display: 'flex', gap: '24px', width: '30%' }}>
            <div style={{ width: '50%' }}>
              <CustomDatePicker
                background="#E4E4E4"
                disabled
                title="Start date"
                required
                value={data?.start_date ? dayjs(data?.start_date) : undefined}
              />
            </div>
            <div style={{ width: '50%' }}>
              {/* <CustomInput
                background="#E4E4E4"
                width="100%"
                disabled
                title="When?"
                // value={data?.start_moment.toUpperCase()}
                value={
                  data?.start_moment?.charAt(0).toUpperCase() +
                  data?.start_moment?.slice(1)
                }
              /> */}
              <CustomDropdown
                disabled
                defaultKey={data?.start_moment}
                options={leave_request_select}
              />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '24px', width: '30%' }}>
            <div style={{ width: '50%' }}>
              <CustomDatePicker
                background="#E4E4E4"
                disabled
                title="End date"
                required
                value={data?.end_date ? dayjs(data?.end_date) : undefined}
              />
            </div>
            <div style={{ width: '50%' }}>
              {/* <CustomInput
                background="#E4E4E4"
                width="100%"
                disabled
                title="When?"
                value={
                  data?.end_moment?.charAt(0).toUpperCase() +
                  data?.end_moment?.slice(1)
                }
              /> */}
              <CustomDropdown
                disabled
                defaultKey={data?.end_moment}
                options={leave_request_select}
              />
            </div>
          </div>
        </div>
      </div>
      {/*PART 2 */}
      <div style={{ marginTop: '32px' }} className={'leave_request_form'}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h1 style={{ fontWeight: 700, fontSize: 20, color: '#000000' }}>
            Which type(s) of absence do you want to request?
          </h1>
          {/* <button className={'leave_request_form_button'}>My balance</button> */}
        </div>
        {/* <Text type={'secondary'}>
            Automatic distribution selects the leave which must be settled as a
            priority
          </Text> */}
        <div style={{ marginTop: '32px', display: 'flex', gap: '32px' }}>
          <CustomInput
            background="#E4E4E4"
            disabled
            title={'Absence type'}
            width={'464px'}
            value={data?.absence_type?.name}
          />
        </div>

        <div className={'leave_request_form_count'}>
          <p style={{
            marginTop: 50,
            gap: 10,
            color: '#000000',
            fontSize: 16,
            fontWeight: 400
          }}>{data?.working_days}</p>
          <p style={{
            marginTop: 50,
            gap: 10,
            color: '#000000',
            fontSize: 16,
            fontWeight: 500
          }}>days</p>
        </div>
      </div>
      {/*PART 3 */}
      <div style={{ marginTop: '32px' }} className={'leave_request_form'}>
        <h1 style={{ fontWeight: 700, fontSize: 20, color: '#000000' }}>Attach File</h1>
        <div className={'leave_request_form_upload'}>
          <h4 style={{ color: '#494949' }}>
            Accepted File Types * (png, .jpg, .jpeg, .gif, .pdf, .docx / Max
            size: 10 mb)
          </h4>
          <div
            style={{
              background: '#E4E4E4',
              borderRadius: '10px',
              border: 'none',
              marginTop: '16px',
              width: ' 100%',
              height: '322px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img alt="upload" src="/icons/upload.svg" />
          </div>
        </div>
      </div>
      {/*PART 4 */}
      <div style={{ marginTop: '32px' }} className={'leave_request_form'}>
        <h1 style={{ color: '#000000', fontSize: '20px', fontWeight: 700, marginBottom: 32 }}>
          Comments
        </h1>
        <input
          value={data?.comment}
          style={{
            background: '#FFFFFF',
            border: '0.5px solid #73A1E7',
            borderRadius: ' 10px',
          }}
          disabled
          className={'leave_request_form_comment'}
          placeholder="Comment"
        />
      </div>
      {/*Button*/}

      <div className={'leave_absence_button_wrapper'} >
        {data?.status === 'to_be_approved' && user?.role === 'admin' ? (
          <div>
            <button
              style={{ background: '#3CD178' }}
              type="submit"
              className={'leave_request_form_submit_button'}
              onClick={() => cancelledRequest('approved')}
            >
              <img src="/icons/submit_icon.svg" alt="submit_icon" />
              APPROVE
            </button>
            <button
              style={{ background: '#F86767' }}
              type="submit"
              className={'leave_request_form_submit_button'}
              onClick={(e) => {
                showModal();
              }}
            >
              <img src="/icons/reject_icon.svg" alt="submit_icon" />
              REJECT
            </button>

          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'row' }} >{(data as any)?.status !== 'cancelled' && (data as any)?.status !== 'rejected' && (
            <div> {user?.role !== 'admin' && (data as any)?.status === 'approved' ? (
              <button
                style={{
                  cursor: 'pointer',
                  color: dayjs() >= dayjs(data?.start_date) ? '#FFF' : '',
                  backgroundColor: dayjs() >= dayjs(data?.start_date) ? '#E4E4E4' : '',
                  width: '302px',
                }}
                onClick={(e) => {
                  showModal1();
                }}
                className={'leave_absence_button'}
                disabled={dayjs() >= dayjs(data?.start_date)}
              >
                <img
                  style={{ marginRight: '10px' }}
                  src={dayjs() >= dayjs(data?.start_date) ? "/icons/cancel3.svg" : "/icons/cancel2.svg"}
                  alt="x"
                />
                SUBMIT TO CANCELLATION
              </button>
            ) : (
              <button
                style={{
                  cursor: dayjs() >= dayjs(data?.start_date) ? 'not-allowed' : 'pointer',
                  color: dayjs() >= dayjs(data?.start_date) ? '#FFF' : '',
                  backgroundColor: dayjs() >= dayjs(data?.start_date) ? '#E4E4E4' : '',
                  width: '228px'
                }}
                onClick={(e) => {
                  showModal();
                }}
                className={'leave_absence_button'}
                disabled={dayjs() >= dayjs(data?.start_date)}
              >
                <img
                  style={{ marginRight: '10px' }}
                  src={dayjs() >= dayjs(data?.start_date) ? "/icons/cancel3.svg" : "/icons/cancel2.svg"}
                  alt="x"
                />
                CANCEL ELEMENT
              </button>
            )}</div>

          )}
            <button
              style={{
                cursor: 'pointer',
                marginLeft: '15px',
              }}
              onClick={() => navigate(NESTEDROUTE.change_request, {
                state: {
                  data: data,
                  status: 'saved'
                },
              })}
              className={'leave_absence_button'}
            >
              <img
                style={{ marginRight: '10px' }}
                src="/icons/icon_save_2.svg"
                alt="x"
              />
              SAVE
            </button>
          </div>)}

      </div >
      <div className='request_modal'>
        <Modal
          closeIcon={null}
          title={null}
          footer={null}
          open={open}
          onOk={() => { hideModal(1) }}
          onCancel={() => { hideModal(0) }}
          width={'400px'}
          style={{ top: '40%' }}
        >
          <div style={{ height: '80px' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              {data?.status === "to_be_approved" && user?.role === 'admin' ? (
                <p style={{ color: '#000', fontSize: '14px', marginLeft: -4, marginTop: -8 }}>
                  Are you sure you want to reject this request?
                </p>
              ) : (
                <p style={{ color: '#000', fontSize: '14px', marginLeft: -4, marginTop: -8 }}>
                  Are you sure you want to cancel this request?
                </p>
              )}
              <img
                style={{ marginLeft: '30px', marginTop: -20, marginRight: -4, cursor: 'pointer' }}
                src="/icons/icon_close.svg"
                alt="x"
                onClick={() => hideModal(0)}
              />
            </div>
            <div style={{ height: '20px' }} />
            <div style={{ marginLeft: '172px' }}>
              <Button
                type={'primary'}
                style={{ width: '84px', height: '36px', color: '#000000', backgroundColor: '#FFFFFF', boxShadow: 'none' }}
                onClick={() => hideModal(0)}

              >
                CLOSE
              </Button>
              <Button
                type={'primary'}
                style={{ width: '84px', height: '36px', marginLeft: '12px', color: '#FFFFFF', backgroundColor: '#F86767', boxShadow: 'none' }}
                onClick={() => {
                  if (data?.status === "to_be_approved" && user?.role === 'admin') {
                    hideModal(2);
                  } else {
                    hideModal(1)
                  }
                }}

              >
                {data?.status === "to_be_approved" && user?.role === 'admin' ? 'REJECT' : 'CANCEL'}

              </Button>
            </div>
          </div>
        </Modal>
      </div>
      <Modal
        closeIcon={null}
        title={null}
        footer={null}
        open={open1}
        onOk={() => { hideModal1(2, 'registered') }}
        onCancel={() => { hideModal1(1, 'registered') }}
        width={'520px'}
        style={{ top: '40%' }}
      >
        <div style={{ height: '388px' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>

            <p style={{ color: '#000', fontSize: '16px', marginLeft: 8, marginTop: 8, fontWeight: 600 }}>
              Submit to cancellation
            </p>

            <img
              style={{ marginLeft: '254px', marginTop: 8, marginRight: 8, cursor: 'pointer', height: 24, width: 24 }}
              src="/icons/icon_close.svg"
              alt="x"
              onClick={() => { hideModal1(1, 'registered') }}
            />
          </div>
          <div style={{ margin: 8, color: '#000000', fontWeight: 400 }}>
            {data?.user.first_name} {data?.user.last_name} {data?.absence_type.name} {data?.start_date} {'-'} {data?.end_date} {'(To be approved)'}
          </div>
          <div style={{ marginTop: '20px' }}>
            <div style={{
              border: '1px solid #407FDD',
              borderRadius: '6px',
              padding: '8px 16px',
              margin: 8,
              height: '170px',
              cursor: 'pointer',
            }}>
              <span style={{ color: '#606060', fontSize: '12px', fontWeight: 400 }}>
                {' '}
                Comments
              </span>{' '}
              <TextArea
                autoSize={{ minRows: 6, maxRows: 6 }}
                placeholder='Write your message here'
                bordered={false}
                style={{ padding: 0, borderRadius: '0px', cursor: 'pointer', pointerEvents: 'auto', fontSize: '12px', height: 118, color: '#000' }}
                size={'large'}
              />
            </div>
          </div>
          <div style={{ marginLeft: '168px', marginTop: '40px' }}>
            <Button
              type={'primary'}
              style={{ width: '84px', height: '36px', color: '#407FDD', backgroundColor: '#F3F8FF', boxShadow: 'none', fontSize: '12px' }}
              onClick={() => { hideModal1(1, 'registered') }}

            >
              CLOSE
            </Button>
            <Button
              type={'primary'}
              style={{ width: '200px', fontSize: '12px', height: '36px', marginLeft: '12px', color: '#FFFFFF', backgroundColor: '#407FDD', boxShadow: 'none' }}
              onClick={() => { hideModal1(2, 'registered') }}

            >
              SUBMIT TO CANCELLATION
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LeaveRequestView;
